import path from 'node:path';
import { randomUUID } from 'node:crypto';
import { toJsonString } from '@wix/cli-fs';
import { componentGenerator } from '@wix/gena';
import type { ActionSchema } from '@wix/cli-app-definitions';
import type { Component } from '@wix/ambassador-devcenter-apps-v1-app-old/types';
import {
  BackOfficeHostingPlatforms,
  ComponentType,
} from '@wix/ambassador-devcenter-apps-v1-app-old/types';
import { getExtensionPath } from '@wix/cli-astro-definitions';

// NOTE: path is relative to the build folder
const DASHBOARD_MENU_PLUGIN_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/dashboard-menu-plugin'
);

export async function generateDashboardMenuPlugin(
  projectFolder: string,
  extended: string,
  action: ActionSchema,
  folder: string,
  title: string
) {
  const component: Component = {
    compId: randomUUID(),
    compType: ComponentType.BACK_OFFICE_EXTENSION_MENU_ITEM,
    compName: folder,
    compData: {
      backOfficeExtensionMenuItem: {
        hostingPlatform: BackOfficeHostingPlatforms.BUSINESS_MANAGER,
        title,
        iconKey: 'Sparkles',
        extends: extended,
        action,
      },
    },
  };

  const cwd = getExtensionPath(projectFolder, folder);
  const menuPluginConfigJSON = toJsonString(component, { spaces: 2 });

  return await componentGenerator({
    template: DASHBOARD_MENU_PLUGIN_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      menuPluginConfigJSON,
    },
  });
}
